import { setCookie, getCookie } from '../base/_utilities';

const modal_element = document.getElementById('apm-dialog');

/**
 *
 *
 *
 */
const init = function() {

	if ( modal_element !== null ) {

		const cookieDuration = ( modal_element.getAttribute( 'data-apm-modal-cookie-duration' ) ) ? modal_element.getAttribute( 'data-apm-modal-cookie-duration' ) : 0;
		const cookieName		 = ( modal_element.getAttribute( 'data-apm-modal-cookie-id' ) ) ? modal_element.getAttribute( 'data-apm-modal-cookie-id' ) : '';
		const modalViewed	 	 = getCookie( cookieName );

		// Instantiate a new A11yDialog module
		const dialog = new A11yDialog(modal_element);

		if ( !modalViewed ) {
			setTimeout( () => {
				dialog.show()
				setCookie(cookieName, true, cookieDuration)
			}, 2000 );
		}

	}

};


const api = {
	init: init
};

export default api;